import type { PropsWithChildren } from 'react'
import { ROLES } from '@/constants/roles'
import { ExpiredToken } from '@/pages/student/expired-token'
import { useStudentSessionStore } from '@/store/student-session-store'

export const AuthStudent = ({ children }: PropsWithChildren) => {
  const studentSession = useStudentSessionStore()

  const verifySession = () => {
    if (studentSession.id) {
      if (ROLES.STUDENT.id === studentSession.role) {
        return true
      }
      return true
    }
    return false
  }

  return verifySession() ? children : <ExpiredToken />
}
